import { z } from "zod"
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from "@/hooks/useFilters"

export type AuditLogEntry = {
  id: string
  occurredAt: Date
  action: string
  entityType: string
  entityId: string
  entityName: string | null
  actorId: string
  actorType: string
  actorDisplay: string
  scopeId: string | null
  entityPath: string | null
  summary: string
  metadata: Record<string, {}> | null
  diff: Record<string, {}> | null
}

export type AuditLogResponse =
  | {
      success: true
      events: AuditLogEntry[]
      totalCount: number
      filterOptions: {
        scopes: Array<string | null>
        users: Array<{ id: string | null; display: string | null }>
        entityTypes: string[]
      }
    }
  | {
      success: false
      error: string
      code: string
    }

export const auditLogQuerySchema = z.object({
  scopeId: z.string().optional().default(""),
  userId: z.string().optional().default(""),
  entityType: z.string().optional().default(""),
  entityId: z.string().optional().default(""),
  /** Prefix filter on action; e.g. "project.create.bulkEdit" finds all save-as-new bulk edits. */
  action: z.string().optional().default(""),
  from: z.string().optional(),
  to: z.string().optional(),
  pageIndex: z.coerce.number().int().min(0).optional().default(DEFAULT_PAGE_INDEX),
  pageSize: z.coerce.number().int().min(1).max(100).optional().default(DEFAULT_PAGE_SIZE),
})

export type AuditLogFilters = z.infer<typeof auditLogQuerySchema>
